import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import ParticipantPreview from 'components/PreClass/Checklist/components/Details/Participant/components/Preview'
import { checklistStatusTypes, checklistErrorTypes } from 'constants/checklist'
import { roomTypes } from 'constants/room'
import { userTypes } from 'helpers/user'
import {
    dispatchSetChecklistError,
    dispatchSetChecklistStatus,
} from 'store/dispatcher'
import { _checklistStatus, _checklistStep } from 'store/selectors/Checklist'
import { _roomType } from 'store/selectors/Room'
import { _userType } from 'store/selectors/User'

import Participants from './components/Participants'
import ParticipantsCount from './components/ParticipantsCount'
import { getActiveCheckCopy } from './helper/participants'
import {
    Container,
    ParticipantWrapper,
    ChecklistCheckWrapper,
    Icon,
    Text,
} from './styles'

const { TEACHER_ALREADY_PRESENT } = checklistErrorTypes
const { IN_PROGRESS, ERROR } = checklistStatusTypes
const { TEACHER, TRIBE_LEADER } = userTypes

const checkTeacherOrTribeLeader = ({ name }) =>
    [TEACHER, TRIBE_LEADER].includes(name.toLowerCase())

const Participant = ({ participants }) => {
    const checklistStatus = useSelector(_checklistStatus)
    const checklistStep = useSelector(_checklistStep)
    const userType = useSelector(_userType)
    const roomType = useSelector(_roomType)

    const renderChecklistCheck = (
        <ChecklistCheckWrapper>
            <Icon src="/img/checklist/checklist-indicator.svg" />
            <Text>{getActiveCheckCopy(checklistStep)}</Text>
        </ChecklistCheckWrapper>
    )

    useMemo(() => {
        const isPreClassHostPresent = participants.some(({ name }) =>
            [TEACHER, TRIBE_LEADER].includes(name.toLowerCase())
        )

        const isLocalUserTypeATeacher = userType.toLowerCase() === TEACHER

        if (isPreClassHostPresent && isLocalUserTypeATeacher) {
            dispatchSetChecklistError(TEACHER_ALREADY_PRESENT)
            dispatchSetChecklistStatus(ERROR)
        }
    }, [participants, userType])

    const preClassHost = participants.find(checkTeacherOrTribeLeader)
    const isRoomTypeNotGS = roomType.toUpperCase() !== roomTypes.GROUP_STUDY
    return (
        <Container noOfParticipants={participants.length}>
            <ParticipantWrapper
                id="participant-tile"
                noOfParticipants={participants.length}
            >
                <ParticipantPreview checkPassed={true} />
                <Participants participants={participants} />
            </ParticipantWrapper>
            {isRoomTypeNotGS && (
                <ParticipantsCount
                    participants={participants.length}
                    preClassHost={preClassHost}
                />
            )}
            {checklistStatus === IN_PROGRESS && renderChecklistCheck}
        </Container>
    )
}

Participant.propTypes = {}

export default Participant
